/**
 * Calendar modules
 */
export * from './calendar';
export * from './islamic';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-calendars/src/calendar/index.js
// module id = 1905
// module chunks = 0